import api from './api';

const academyService = {
  // Mis cursos (partner)
  getMyCourses: async (params) => (await api.get('/academy/courses/partner/my', { params })).data,
  createCourse: async (data) => (await api.post('/academy/courses/partner', data)).data,
  updateCourse: async (id, data) => (await api.put(`/academy/courses/partner/${id}`, data)).data,
  deleteCourse: async (id) => (await api.delete(`/academy/courses/partner/${id}`)).data,

  // Instructores del partner
  getMyInstructors: async () => (await api.get('/academy/instructors/partner/my')).data,
  createInstructor: async (data) => (await api.post('/academy/instructors/partner', data)).data,
  updateInstructor: async (id, data) => (await api.put(`/academy/instructors/partner/${id}`, data)).data,

  // Stats
  getMyStats: async () => (await api.get('/academy/courses/partner/stats')).data,
  getMyEnrollments: async (params) => (await api.get('/academy/courses/partner/enrollments', { params })).data,

  // Crear curso con IA (retorna jobId para polling)
  agentCreate: async (data) => {
    const response = await api.post('/academy/courses/partner/agent/create', data);
    return response.data;
  },

  // Consultar estado de job de generacion IA
  agentJobStatus: async (jobId) => {
    const response = await api.get(`/academy/courses/agent/job/${jobId}`);
    return response.data;
  },

  // Cursos globales (solo lectura)
  getGlobalCourses: async (params) => (await api.get('/academy/courses/public', { params: { ...params, scope: 'global' } })).data,

  // Detalle de un curso publicado, CON el temario completo. La lista de arriba le quita a cada
  // lección su videoUrl/fileUrl; para ver los videos o abrir los documentos hace falta este.
  getCourseDetail: async (courseId) => (await api.get(`/academy/courses/public/by-id/${courseId}`)).data?.data || null,

  // Upload de imagenes del curso (thumbnail, coverImage) a Firebase Storage
  uploadCourseImage: async (courseId, file, type) => {
    const formData = new FormData();
    formData.append('image', file);
    // Override del default 'application/json' del cliente: pasar undefined fuerza
    // a axios a derivar 'multipart/form-data; boundary=...' al detectar FormData.
    const response = await api.post(
      `/academy/courses/partner/${courseId}/image?type=${type}`,
      formData,
      { headers: { 'Content-Type': undefined } }
    );
    return response.data;
  },
  deleteCourseImage: async (courseId, url, type) => {
    const response = await api.delete(
      `/academy/courses/partner/${courseId}/image`,
      { data: { url, type } }
    );
    return response.data;
  },

  // ── Consumo de cursos como ESTUDIANTE (docs/120 F5b/F8 — "Mi aprendizaje" del consultor cd-2b) ──
  // Todo lo de arriba es del lado INSTRUCTOR (crear/editar SUS PROPIOS cursos). Esto es el lado
  // alumno: inscribirse, ver progreso y completar lecciones de los cursos globales de Academy
  // (`scope:'global'`, `category:'cd2b_consultor'`, ver `getGlobalCourses`). Rutas verificadas
  // contra `api/src/routes/academy/enrollmentRoutes.js` (montadas en `/v1/academy/enrollments`).

  /** Inscribe al asesor autenticado en un curso. `courseId` del catálogo global. */
  enroll: async (courseId) => (await api.post('/academy/enrollments/enroll', { courseId })).data,

  /**
   * Mis inscripciones DE ESTUDIANTE (con progreso), para pintar "% completado" en cada curso de
   * la ruta de estudio. Nombre distinto de `getMyEnrollments` de arriba a propósito: aquella es
   * el lado INSTRUCTOR (quién se inscribió en MIS cursos) — mismo verbo, endpoint y sentido
   * opuestos; reusar el nombre habría chocado como clave duplicada en este mismo objeto.
   */
  getMyStudentEnrollments: async (params) => (await api.get('/academy/enrollments/my', { params })).data,

  /** Progreso detallado de UNA inscripción (lección por lección). */
  getEnrollmentProgress: async (enrollmentId) => (await api.get(`/academy/enrollments/${enrollmentId}/progress`)).data,

  /** Marca una lección como completada dentro de una inscripción (por índice de módulo/lección, no por id). */
  markLessonComplete: async (enrollmentId, moduleIndex, lessonIndex) =>
    (await api.put(`/academy/enrollments/${enrollmentId}/lesson-complete`, { moduleIndex, lessonIndex })).data,

  /** Envía respuestas del quiz de autoevaluación de una lección (NO certifica — eso es el examen de Cd2bCertificacion). */
  submitQuiz: async (enrollmentId, moduleIndex, lessonIndex, answers) =>
    (await api.post(`/academy/enrollments/${enrollmentId}/quiz`, { moduleIndex, lessonIndex, answers })).data,

  /** Certificado de FINALIZACIÓN DEL CURSO (`academy_enrollments.certificate`) — distinto de la insignia de certificación. */
  getEnrollmentCertificate: async (enrollmentId) => (await api.get(`/academy/enrollments/${enrollmentId}/certificate`)).data,
};

export default academyService;
